export default __webpack_public_path__ + "static/media/logo.0531b632.svg";